export default __webpack_public_path__ + "static/media/Skystorm.4e4f436b.jpg";